/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InstituteAddress } from './InstituteAddress';
import {
    InstituteAddressFromJSON,
    InstituteAddressFromJSONTyped,
    InstituteAddressToJSON,
    InstituteAddressToJSONTyped,
} from './InstituteAddress';

/**
 * 
 * @export
 * @interface CreateUpdateInstituteRequest
 */
export interface CreateUpdateInstituteRequest {
    /**
     * the unique identifier of the institute
     * @type {string}
     * @memberof CreateUpdateInstituteRequest
     */
    instituteId?: string;
    /**
     * the name of the institute
     * @type {string}
     * @memberof CreateUpdateInstituteRequest
     */
    name?: string;
    /**
     * the shortname of the institute
     * @type {string}
     * @memberof CreateUpdateInstituteRequest
     */
    shortName?: string;
    /**
     * the external id of the institute
     * @type {string}
     * @memberof CreateUpdateInstituteRequest
     */
    externalId?: string;
    /**
     * the role of the institute
     * @type {string}
     * @memberof CreateUpdateInstituteRequest
     */
    instituteRole?: string;
    /**
     * tell if the PID is active for that institute
     * @type {boolean}
     * @memberof CreateUpdateInstituteRequest
     */
    pidactive?: boolean;
    /**
     * tell if the fast patient creation feature is active for that institute
     * @type {boolean}
     * @memberof CreateUpdateInstituteRequest
     */
    fastPatientCreationActive?: boolean;
    /**
     * tell if the ophthalmoDashboard is active for that institute
     * @type {boolean}
     * @memberof CreateUpdateInstituteRequest
     */
    ophthalmoDashboardActive?: boolean;
    /**
     * 
     * @type {InstituteAddress}
     * @memberof CreateUpdateInstituteRequest
     */
    instituteAddress?: InstituteAddress;
}

/**
 * Check if a given object implements the CreateUpdateInstituteRequest interface.
 */
export function instanceOfCreateUpdateInstituteRequest(value: object): value is CreateUpdateInstituteRequest {
    return true;
}

export function CreateUpdateInstituteRequestFromJSON(json: any): CreateUpdateInstituteRequest {
    return CreateUpdateInstituteRequestFromJSONTyped(json, false);
}

export function CreateUpdateInstituteRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateUpdateInstituteRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'instituteId': json['instituteId'] == null ? undefined : json['instituteId'],
        'name': json['name'] == null ? undefined : json['name'],
        'shortName': json['shortName'] == null ? undefined : json['shortName'],
        'externalId': json['externalId'] == null ? undefined : json['externalId'],
        'instituteRole': json['instituteRole'] == null ? undefined : json['instituteRole'],
        'pidactive': json['pidactive'] == null ? undefined : json['pidactive'],
        'fastPatientCreationActive': json['fastPatientCreationActive'] == null ? undefined : json['fastPatientCreationActive'],
        'ophthalmoDashboardActive': json['ophthalmoDashboardActive'] == null ? undefined : json['ophthalmoDashboardActive'],
        'instituteAddress': json['instituteAddress'] == null ? undefined : InstituteAddressFromJSON(json['instituteAddress']),
    };
}

export function CreateUpdateInstituteRequestToJSON(json: any): CreateUpdateInstituteRequest {
    return CreateUpdateInstituteRequestToJSONTyped(json, false);
}

export function CreateUpdateInstituteRequestToJSONTyped(value?: CreateUpdateInstituteRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'instituteId': value['instituteId'],
        'name': value['name'],
        'shortName': value['shortName'],
        'externalId': value['externalId'],
        'instituteRole': value['instituteRole'],
        'pidactive': value['pidactive'],
        'fastPatientCreationActive': value['fastPatientCreationActive'],
        'ophthalmoDashboardActive': value['ophthalmoDashboardActive'],
        'instituteAddress': InstituteAddressToJSON(value['instituteAddress']),
    };
}

